import { ReactNode } from 'react';
import { BorderTheme, CardTheme } from 'components/common/Card/Card.types';
import { TooltipDirection } from 'lib/Tooltip';
import { ValueOf } from 'components/common/types/ValueOf';

export const INFO_TYPE = {
  CARD: 'CARD',
  TOOLTIP: 'TOOLTIP',
} as const;

export type InfoType = ValueOf<typeof INFO_TYPE>;

export interface InfoMessageProps {
  children?: ReactNode;
  type?: InfoType;
  icon?: ReactNode;
  direction?: ValueOf<typeof TooltipDirection>;
  borderTheme?: BorderTheme;
  cardTheme?: CardTheme;
}
